<div
  class="sidebar"
  data-active-color="danger"
  data-color="white"
  data-image="./assets/img/sidebar-1.jpg"
>
  <div class="sidebar-wrapper">
    <div class="user">
      <div class="photo">
        <img [src]="getProfileImage()" alt="Profile" />
      </div>
      <div class="info">
        <a class="collapsed" data-toggle="collapse" href="#collapseExample">
          <span>
            {{ getProfileName() }}
            <b class="caret"></b>
          </span>
        </a>
        <div class="clearfix"></div>
        <div class="collapse" id="collapseExample">
          <ul class="nav">
            <li
              *ngFor="let menuitem of upperMenuRoutes"
              routerLinkActive="active"
            >
              <!--If is a single link-->
              <a
                *ngIf="menuitem.type === 'link'"
                [routerLink]="[menuitem.path]"
              >
                <i class="{{ menuitem.icontype }}"></i>
                <p>
                  {{ menuitem.title }}
                  <span
                    *ngIf="menuitem.showBadge == true"
                    class="badge badge-primary"
                    >{{ menuitem.badge }}</span
                  >
                </p>
              </a>
              <!--If it have a submenu-->
              <a
                *ngIf="menuitem.type === 'sub'"
                data-toggle="collapse"
                href="#{{ menuitem.collapse }}"
              >
                <i class="{{ menuitem.icontype }}"></i>
                <p>{{ menuitem.title }}<b class="caret"></b></p>
              </a>

              <!--Display the submenu items-->
              <div
                *ngIf="menuitem.type === 'sub'"
                class="collapse"
                id="{{ menuitem.collapse }}-m"
              >
                <ul class="nav">
                  <li
                    *ngFor="let childitem of menuitem.children"
                    routerLinkActive="active"
                  >
                    <a [routerLink]="[menuitem.path, childitem.path]">
                      <span class="sidebar-mini-icon">{{ childitem.ab }}</span>
                      <span class="sidebar-normal">{{ childitem.title }}</span>
                    </a>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <ul class="nav">
      <li *ngFor="let menuitem of currentRoutes" routerLinkActive="active">
        <!--If is a single link-->
        <a *ngIf="menuitem.type === 'link'" [routerLink]="[menuitem.path]">
          <i class="{{ menuitem.icontype }}"></i>
          <p>
            {{ menuitem.title }}
            <span
              *ngIf="menuitem.showBadge == true"
              class="badge badge-primary"
              >{{ getNotificationBadge() }}</span
            >
          </p>
        </a>
        <!--If it have a submenu-->
        <a
          *ngIf="menuitem.type === 'sub'"
          data-toggle="collapse"
          href="#{{ menuitem.collapse }}"
        >
          <i class="{{ menuitem.icontype }}"></i>
          <p>{{ menuitem.title }}<b class="caret"></b></p>
        </a>

        <!--Display the submenu items-->
        <div
          *ngIf="menuitem.type === 'sub'"
          class="collapse"
          id="{{ menuitem.collapse }}"
        >
          <ul class="nav">
            <li
              *ngFor="let childitem of menuitem.children"
              routerLinkActive="active"
            >
              <a [routerLink]="(menuitem.path ?? '') + (childitem.path ?? '')">
                <span class="sidebar-mini-icon">{{ childitem.ab }}</span>
                <span class="sidebar-normal">{{ childitem.title }}</span>
              </a>
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </div>
</div>
